const doc = [({"da":({"js":({"reimbursements":({"documents_button":({"carousel":({"image_current_of_total":"Billede %{current} af %{total}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;